import { render, staticRenderFns } from "./GeneralConfiguration.vue?vue&type=template&id=09a4ab5b&scoped=true"
import script from "./GeneralConfiguration.vue?vue&type=script&lang=js"
export * from "./GeneralConfiguration.vue?vue&type=script&lang=js"
import style0 from "./GeneralConfiguration.vue?vue&type=style&index=0&id=09a4ab5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a4ab5b",
  null
  
)

export default component.exports